module.exports = __webpack_public_path__ + "static/img/game-Horizon-Zero-Dawn_PC.5169969.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game/game-Horizon-Zero-Dawn_PC.jpg
// module id = yEdH
// module chunks = 0